<template>
  <div class="account-admin container">
    <div class="row mb-2">
      <div class="col-12 col-md-6">
        <h1>Accounts</h1>
      </div>

      <div class="col-12 col-md-6 text-right">
        <div class="search-with-button">
          <div class="search-input">
            <input v-model="search" type="search" placeholder="Search..." />
            <font-awesome-icon :icon="['fas', 'search']" class="icon alt" />
          </div>
          <button type="button" class="btn btn-primary" @click="generateCsv">
            <font-awesome-icon
              v-if="csvGenerating"
              :spin="true"
              :icon="['fas', 'spinner']"
              class="icon alt"
            />
            <span v-else>Export CSV</span>
          </button>
        </div>
      </div>

      <div class="col-12">
        <hr />
      </div>
    </div>

    <router-view
      :search="search"
      :csv-bus="csvBus"
      @impersonate="impersonate"
    />
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'SuperAdminAccounts',

  data() {
    return {
      search: '',

      csvBus: new Vue(),
      csvGenerating: false
    };
  },

  mounted() {
    this.csvBus.$on('success', this.downloadCsv);
    this.csvBus.$on('error', this.showCsvError);
  },

  methods: {
    generateCsv() {
      this.csvGenerating = true;
      this.csvBus.$emit('generate');
    },
    downloadCsv({ content, file }) {
      const downloadLink = document.createElement('a');
      const blob = new Blob(['\ufeff', content]);
      downloadLink.href = URL.createObjectURL(blob);
      downloadLink.download = file;

      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

      this.csvGenerating = false;
    },
    showCsvError(error) {
      this.$store.commit('setGlobalAlert', {
        msg: `Failed to generate CSV: ${error}`,
        error: true
      });

      this.csvGenerating = false;
    },

    impersonate(id) {
      this.$localStorage.set('impersonateId', id.toString());
      window.location.assign('/');
    }
  }
};
</script>

<style lang="scss" scoped>
.account-admin {
  ::v-deep .btn-group {
    margin-top: 8px;

    @media (max-width: $sm-max) {
      width: 100%;
    }

    .btn {
      @include border-radius($border-radius);

      background: rgba(255, 255, 255, 0.25);
      color: $white;
      margin-right: 5px;
      font-weight: normal;
      outline: 0;
      box-shadow: none;

      @media (min-width: $xl-min) {
        min-width: 120px;
      }

      &.last {
        margin-right: 0;
      }

      &.active {
        background-color: $white;
        color: rgba(0, 0, 0, 0.76);
      }

      @media (max-width: $sm-max) {
        width: 25%;
      }
    }

    &.tabs-table {
      outline-offset: 1px;

      .btn {
        padding-right: 35px;
        padding-left: 35px;
        background: transparentize($color: $dark-blue, $amount: 0.5);
        color: transparentize($color: $white, $amount: 0.5);
        border: 0;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        text-transform: uppercase;
        font-size: 0.9rem;
        letter-spacing: 0.01rem;

        &:hover,
        &:focus {
          color: $white;
          background: $dark-blue;
        }

        &.active {
          color: $white;
          background: $dark-blue;

          &:hover {
            cursor: default;
          }
        }
      }
    }
  }

  .search-with-button {
    .search-input {
      display: inline-block;
      vertical-align: top;
      width: calc(100% - 135px);
    }

    .btn {
      display: inline-block;
      vertical-align: top;
      width: 130px;
      margin-left: 5px;
      height: 45px;
    }
  }
}
</style>
